const readRateName = (rate) => rate.parameterName || rate.name;

const orderRateNames = (counts, published) => {
  const counted = Object.keys(counts);
  const ordered = published.map(readRateName).filter((rateName) => counted.includes(rateName));
  const rest = counted.filter((rateName) => !ordered.includes(rateName));
  return [...ordered, ...rest];
};

const buildTourTravelerRows = (tourItinerary) => {
  const counts = tourItinerary?.selectedSlot?.rateQuantities || {};
  const published = tourItinerary?.tour?.rates || [];
  const rows = [];

  orderRateNames(counts, published).forEach((rateName) => {
    const rate = published.find((candidate) => readRateName(candidate) === rateName);
    for (let guest = 1; guest <= counts[rateName]; guest += 1) {
      rows.push({ rateName, rate, indexInRate: guest });
    }
  });

  return rows;
};

export default buildTourTravelerRows;
